import React, { Component } from "react";

export default class SubmitRequest extends Component {
  render() {
    return <div>sumbit process</div>;
  }
}
